import { render } from "./ComplianceConsultChat.vue?vue&type=template&id=510448d5&scoped=true"
import script from "./ComplianceConsultChat.vue?vue&type=script&lang=js"
export * from "./ComplianceConsultChat.vue?vue&type=script&lang=js"

import "./ComplianceConsultChat.vue?vue&type=style&index=0&id=510448d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510448d5"]])

export default __exports__